import script from "./AddValueCharMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AddValueCharMenu.vue?vue&type=script&setup=true&lang=js"

import "./AddValueCharMenu.vue?vue&type=style&index=0&id=341de3b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341de3b9"]])

export default __exports__